import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useToggleSideNav = () => {
  const user = useUser();
  const updateUserSettings = useUpdateUserSettings();

  const open = !user?.settings?.webSideNavigationClosed;
  const set = useCallback(
    (open: boolean) =>
      updateUserSettings({
        webSideNavigationClosed: !open,
      }),
    [updateUserSettings],
  );

  const toggle = useCallback(
    () =>
      updateUserSettings({
        // should be open, as open is the opposite of webSideNavigationClosed
        webSideNavigationClosed: open,
      }),
    [open, updateUserSettings],
  );

  return {
    open,
    toggle,
    set,
  };
};
